// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>

    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_MCC_FOLLOWUP_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push(`/claims/mcc-followup/new/${claim.pin}`));

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/additional-repair.js